import ConfirmView from './ConfirmView';

export default ConfirmView;
